const TMS_HOME_CONNECT_UI = 'tmsHomeConnectUi';

const TMS_BASE_URL = 'app/tms_cdn/public/translations';

const DEV = 'development'
const CDN_DEV = 'cdn_dev'
const QA4 = 'qa4'
const INTG = 'intg'
const CDN_INTG = 'cdn_intg'
const QA2 = 'qa2'
const CDN_QA2 = 'cdn_qa2'
const PREPROD = 'preprod'
const CDN_PREPROD = 'cdn_preprod'
const PROD = 'production'
const CDN_PROD = 'cdn_prod'

const TMSUUIDS = (env) => {
    switch (env) {
        case DEV:
        case CDN_DEV:
        case QA4:
            return 'd1094791-373d-41ae-8914-b9040330e2a1';
        case INTG:
        case CDN_INTG:
            return '0e6457e0-53e3-4add-a676-d8fe8ed4b22c';
        case QA2:
        case CDN_QA2:
            return '4ff46574-cd95-48bf-a1f0-9eb4e51605c0';
        case PREPROD:
        case CDN_PREPROD:
            return '27fea2c2-52c5-4a94-a517-861d9ef75e5d';
        case PROD:
        case CDN_PROD:
            return 'd1094791-373d-41ae-8914-b9040330e2a1';
        default:
            return 'd1094791-373d-41ae-8914-b9040330e2a1';
    }
};

export {
    TMS_HOME_CONNECT_UI,
    TMS_BASE_URL,
    TMSUUIDS
}